module.exports = __webpack_public_path__ + "static/person-bubble-5-548edf11147707947e38e7db493cf19c.png";